import { Component, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private toastController: ToastController) { }

  async presentToast(message: any, messageColor = 'light') {
    const danger = messageColor === 'danger';
    const toast = await this.toastController.create({
      message:      message,
      duration:     danger ? 0 : 4000,
      position:     'top',
      color:        messageColor,
      cssClass:     'alert-toast',
      animated:     true,
      translucent:  true,
      buttons:      danger ? [{text: 'Закрыть', role: 'cancel'}] : [],
    })
    .then((instance) => {
      instance.present();
    });
  }
}
